module.exports = __webpack_public_path__ + "img/3w-d.d4fc3735.png";